import type { ClientPost } from '@DigitaleDoerfer/digitale-doerfer-api';

import type { GenericPostDetail } from '@/features/posts/types/posts';
import { getPostProps } from '@/features/posts/utils/post';

export const flattenPostsToGenericPostDetails = (
  posts: ClientPost[] | undefined | null
): GenericPostDetail[] =>
  (posts ?? [])
    .map((post) => getPostProps(post))
    .filter((post): post is GenericPostDetail => post !== undefined);
